import src from "IMAGE";
export default { src, width: 1170, height: 780, blurWidth: 0, blurHeight: 0};
